import request from '@/utils/request'

// 创建专属会议号
export function createUniqueVirtual(data) {
  return request({
    url: '/yuzhen/unique-virtual/create',
    method: 'post',
    data: data
  })
}

// 更新专属会议号
export function updateUniqueVirtual(data) {
  return request({
    url: '/yuzhen/unique-virtual/update',
    method: 'put',
    data: data
  })
}

// 删除专属会议号
export function deleteUniqueVirtual(id) {
  return request({
    url: '/yuzhen/unique-virtual/delete?id=' + id,
    method: 'delete'
  })
}

// 获得专属会议号
export function getUniqueVirtual(id) {
  return request({
    url: '/yuzhen/unique-virtual/get?id=' + id,
    method: 'get'
  })
}

// 获得专属会议号分页
export function getUniqueVirtualPage(query) {
  return request({
    url: '/yuzhen/unique-virtual/page',
    method: 'get',
    params: query
  })
}

// 导出专属会议号 Excel
export function exportUniqueVirtualExcel(query) {
  return request({
    url: '/yuzhen/unique-virtual/export-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

// 获得专属会议号(过期的搜索不到)
export function getUniqueVirtualAll() {
  return request({
    url: '/yuzhen/unique-virtual/all',
    method: 'get'
  })
}

// 获得专属会议号(包括过期未删除的)
export function getAllUniqueVirtual() {
  return request({
    url: '/yuzhen/unique-virtual/user/all',
    method: 'get'
  })
}

// 查询出7天内即将过期的会议号
export function getExpiredVirtual() {
  return request({
    url: '/yuzhen/unique-virtual/expired',
    method: 'get'
  })
}

